var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-h-80" },
    [
      _c(
        "div",
        {
          staticClass:
            "steps mt-8 lg:mt-16 container px-4 mx-auto text-center relative"
        },
        [
          _c("ul", { staticClass: "flex p-0 m-0 w-full" }, [
            _c(
              "li",
              { staticClass: "mx-2 text-left" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "checkout cart" } } },
                  [
                    _vm._v(
                      _vm._s(_vm.data.translations.cart) + "\n                "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "mx-2" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "checkout addresses" },
                      event: _vm.cart.isEmpty ? "" : "click"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.data.translations.addresses) +
                        "\n                "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "mx-2 text-right" },
              [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: { name: "checkout payment" },
                      event: _vm.cart.isEmpty
                        ? ""
                        : !_vm.cart.email
                        ? ""
                        : "click"
                    }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.data.translations.payment) +
                        "\n                "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "meter" }, [_c("vue-progress-bar")], 1),
          _vm._v(" "),
          _c("loading", {
            staticClass: "mt-40 md:mt-48 h-32",
            attrs: {
              active: _vm.isLoading,
              "can-cancel": false,
              "is-full-page": false
            },
            on: {
              "update:active": function($event) {
                _vm.isLoading = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "keep-alive",
        { attrs: { exclude: "CheckoutPayment" } },
        [_c("router-view", { attrs: { data: _vm.data } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }